import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectsWithPhasesListReducer(state = initialState.projectsWithPhasesList, action) {

    const mergeInProjectWithPhases = (projectsWithPhases, projectUpdate) => {
        const projectsMinusStaleData = projectsWithPhases.filter(p => p.id !== projectUpdate.id);
        return projectsMinusStaleData.concat(projectUpdate);
    }   

    switch (action.type) {
        case types.LOAD_PROJECT_WITH_PHASES_SUCCESS:      
            return mergeInProjectWithPhases(state, action.project);   
        case types.CREATED_INVOICE_SUCCESS:       
            return mergeInProjectWithPhases(state,action.invoice.project);
        default:
            return state;
    }
}